import {endpoints} from '~/network/endpoints';
import {useHttpRequest} from '~/composables/useHttpRequest';

/**
 * Follow a player (PRIVACY_PLAN.md §3.6). Thin calls over the API; the rules
 * (adults only, no club mates, no Hidden people, cooldowns) are the API's, and
 * a refusal arrives as a 400 whose global[0] is the sentence to show.
 */
export function useFollows() {
  const {httpRequest} = useHttpRequest();

  /** @returns {Promise<Array>} the viewer's links: direction "sent" | "received", status 0 pending / 1 accepted */
  const list = () => httpRequest(endpoints.userFollows.list);

  /** An admin's queue: requests to follow players with no account in these clubs. */
  const pendingForClubs = (clubIds) => httpRequest(endpoints.userFollows.pendingForClubs, {clubIds});

  /** The one person with this user tag (exact): a stranger reads as "First L.", a club mate in full. */
  const search = (query) => httpRequest(endpoints.userFollows.search, {query});

  const request = (playerId) => httpRequest(endpoints.userFollows.request, {playerId});
  const accept = (id) => httpRequest(endpoints.userFollows.accept(id));
  const decline = (id) => httpRequest(endpoints.userFollows.decline(id));
  /** Cancel a request you sent, or unfollow. */
  const remove = (id) => httpRequest(endpoints.userFollows.remove(id));

  /** The sentence from a refused call, or a fallback. */
  const reasonOf = (e) => e?.global?.[0] ?? e?.message ?? 'That did not work. Try again.';

  return {list, pendingForClubs, search, request, accept, decline, remove, reasonOf};
}

/** How a follow state reads on a button, one place for every surface. */
export const FOLLOW_LABELS = {
  none: 'Follow',
  requested: 'Requested',
  requestReceived: 'Accept request',
  following: 'Following',
};
